<div class="client-portal-wrapper h-100">
  <p-tabs
    value="0"
    [scrollable]="true"
    [showNavigators]="true"
    styleClass="client-portal-tabs min-hgt-rounded pt-0 ">
    <p-tablist>
      <p-tab value="0" class="pb-1">Client Access</p-tab>
      <p-tab value="1" class="pb-1">Client Document</p-tab>
      <p-tab value="2" class="pb-1">Project Link</p-tab>
    </p-tablist>

    <p-tabpanels class="p-0 pt-1 h-100 flex-grow-1">
      <!-- Nadel Portal Tab -->
      <p-tabpanel value="0" class="flex-grow-1 h-100">
        <div
          class="client-portal-content pt-2 flex-grow-1 min-vh-0 d-flex flex-column gap-2">
          <div
            class="d-flex justify-content-between align-items-center custom-padding py-2 gap-2 align-self-stretch flex-wrap">
            <span class="fw-normal fs-6">Project Access</span>
            <div
              class="d-flex gap-2 client-portal-content-header-btns"
              [class.pe-none]="!isClientPortalEnabled"
              [class.opacity-75]="!isClientPortalEnabled"
              [attr.inert]="!isClientPortalEnabled ? '' : null">
              <p-button
                label="Add Group"
                [disabled]="accessBusy() || !accessReady()"
                [outlined]="true"
                size="small"
                severity="success"
                (click)="openAddGroupModal()" />
              <p-button
                label="Add Additional"
                [disabled]="accessBusy() || !accessReady()"
                [outlined]="true"
                size="small"
                severity="success"
                (click)="toggleAddAdditionalInput()" />
            </div>
          </div>

          @if (isClientPortalAccessLoading) {
            <div
              class="flex-grow-1 min-vh-0 d-flex align-items-center justify-content-center"
              role="status"
              aria-live="polite">
              <jni-spinner></jni-spinner>
              <span class="visually-hidden">Checking Nadel Portal access</span>
            </div>
          } @else if (isClientPortalEnabled) {
            <!-- Project Access User List -->
            @if (accessBusy()) {
              <p role="status" class="px-2 mb-0">Updating project access…</p>
            }
            @if (accessError()) {
              <div role="alert" class="px-2">
                <p class="text-danger mb-1">{{ accessError() }}</p>
                <p-button
                  label="Refresh access"
                  [disabled]="accessBusy()"
                  (onClick)="loadProjectAccess()" />
              </div>
            }
            <div
              class="d-flex flex-column justify-content-start align-items-stretch align-self-stretch min-vh-0 flex-grow-1 mb-2 order-2">
              <!-- Individual Users -->
              <div
                *ngFor="let user of projectAccessUsers; let i = index"
                class="d-flex justify-content-between align-items-center project-access-user-row custom-padding py-2"
                [class.new-user-highlight]="user.isNew">
                <div
                  class="d-flex align-items-start gap-2 project-access-user-main">
                  <i class="pi pi-user" style="font-size: 1.2rem"></i>
                  <div class="project-access-user-text">
                    <div
                      #emailEl
                      class="fw-normal project-access-user-row-email w-100 d-block text-truncate"
                      [class.text-warning]="user.isNew"
                      [class.access-unapproved]="isUnapproved(user)"
                      [pTooltip]="
                        isUnapproved(user)
                          ? user.email +
                            ' — pending approval. Email not sent until approved.'
                          : user.email
                      "
                      tooltipPosition="top">
                      {{ user.email }}
                    </div>
                    <div class="d-flex align-items-center gap-2 flex-wrap">
                      <small class="project-access-user-row-role fw-light">{{
                        user.isPrimaryBuyer ? "Primary Buyer" : "Additional"
                      }}</small>
                      <p-tag
                        *ngIf="isUnapproved(user)"
                        icon="pi pi-clock"
                        value="Pending approval"
                        styleClass="access-pending-tag"
                        pTooltip="Access granted but awaiting approval. Email not sent until approved."
                        tooltipPosition="top" />
                    </div>
                  </div>
                </div>
                <div class="d-flex align-items-center gap-2">
                  <i
                    *ngIf="
                      user.userId !== undefined &&
                      !isUnapproved(user) &&
                      !accessBusy() &&
                      accessReady()
                    "
                    class="pi pi-envelope pointer"
                    pTooltip="Resend Email"
                    tooltipPosition="top"
                    (click)="resendEmail(user)"></i>
                  <i
                    *ngIf="isUnapproved(user)"
                    class="pi pi-clock pointer access-pending-icon"
                    pTooltip="Go to access approvals"
                    tooltipPosition="top"
                    (click)="openAccessApprovals()"></i>
                  <i
                    class="pi pi-trash text-danger pointer"
                    (click)="removeProjectAccessUser(i)"></i>
                </div>
              </div>

              <div
                *ngFor="let user of pendingProjectAccessUsers"
                class="d-flex justify-content-between align-items-center project-access-user-row access-pending-row custom-padding py-2">
                <div
                  class="d-flex align-items-start gap-2 project-access-user-main">
                  <i class="pi pi-user"></i>
                  <div class="project-access-user-text">
                    <div
                      class="fw-normal project-access-user-row-email w-100 d-block text-truncate access-unapproved"
                      [pTooltip]="
                        user.email +
                        ' — pending approval. Email not sent until approved.'
                      "
                      tooltipPosition="top">
                      {{ user.email }}
                    </div>
                    <div class="d-flex align-items-center gap-2 flex-wrap">
                      <small class="project-access-user-row-role fw-light"
                        >Additional</small
                      >
                      <p-tag
                        icon="pi pi-clock"
                        value="Pending approval"
                        styleClass="access-pending-tag"
                        pTooltip="Access request submitted and awaiting approval. This entry is view-only until approved."
                        tooltipPosition="top" />
                    </div>
                  </div>
                </div>
                <div class="d-flex align-items-center gap-2">
                  <i
                    class="pi pi-exclamation-triangle pointer access-pending-icon"
                    pTooltip="Go to access approvals"
                    tooltipPosition="top"
                    (click)="openAccessApprovals()"></i>
                </div>
              </div>

              <!-- Groups -->
              <div
                *ngFor="let group of projectAccessGroups; let i = index"
                class="project-access-group mb-1">
                <div [pTooltip]="!group.groupIsEnable ? 'Disabled Group' : ''">
                  <div
                    class="d-flex justify-content-between align-items-start py-2 pointer"
                    (click)="toggleProjectAccessGroup(group)"
                    [class.disabled-div]="!group.groupIsEnable"
                    tooltipPosition="top">
                    <div
                      class="d-flex align-items-start gap-2 project-access-user-main">
                      <i class="pi pi-users"></i>
                      <div class="project-access-user-text">
                        <div
                          #groupNameEl
                          class="fw-normal project-access-user-row-email w-100 d-block text-truncate link-text"
                          [pTooltip]="group.name"
                          tooltipPosition="top"
                          [tooltipDisabled]="
                            groupNameEl.scrollWidth <= groupNameEl.clientWidth
                          ">
                          {{ group.name }}
                        </div>
                        <small class="project-access-user-row-role fw-light"
                          >{{ group.users.length }} Users</small
                        >
                      </div>
                    </div>
                    <div class="d-flex align-items-center gap-2">
                      <i
                        *ngIf="group.users.length > 0"
                        class="pi"
                        [ngClass]="
                          group.expanded ? 'pi-chevron-up' : 'pi-chevron-down'
                        "
                        style="font-size: 0.8rem"></i>
                      <i
                        class="pi pi-trash text-danger pointer"
                        (click)="
                          removeProjectAccessGroup(i); $event.stopPropagation()
                        "></i>
                    </div>
                  </div>
                </div>

                <!-- Expanded Group Users -->
                <div
                  *ngIf="group.users.length > 0 && group.expanded"
                  class="group-users-expanded ps-4">
                  <div
                    *ngFor="let user of group.users"
                    class="d-flex align-items-center gap-2 py-1">
                    <i class="pi pi-user"></i>
                    <span
                      #groupUserEl
                      class="small group-user-name d-block text-truncate"
                      [class.access-unapproved]="isUnapproved(user)"
                      [pTooltip]="
                        isUnapproved(user)
                          ? user.email +
                            ' — pending approval. Email not sent until approved.'
                          : user.name
                      "
                      tooltipPosition="top">
                      {{ user.email }}
                    </span>
                    <p-tag
                      *ngIf="isUnapproved(user)"
                      icon="pi pi-clock"
                      value="Pending approval"
                      styleClass="access-pending-tag"
                      pTooltip="Access granted but awaiting approval. Email not sent until approved."
                      tooltipPosition="top" />
                  </div>
                </div>
              </div>
            </div>

            <!-- Add Additional Input -->
            <div
              *ngIf="showAddAdditionalInput"
              class="mt-0 custom-padding order-1">
              <label class="form-label fw-medium">Additional</label>
              <div class="d-flex align-items-center additional-input-div mt-1">
                <p-autocomplete
                  [formControl]="additionalUserControl"
                  [suggestions]="additionalSuggestions"
                  [field]="'email'"
                  [dropdown]="false"
                  [forceSelection]="false"
                  placeholder="Enter email"
                  styleClass=" px-0"
                  [ariaLabel]="'Additional user email'"
                  [attr.aria-invalid]="additionalEmailError ? true : null"
                  (input)="additionalEmailError = ''"
                  (completeMethod)="searchAdditionalUsers($event)"
                  (onSelect)="onAdditionalUserSelect($event)" />
                <p-button
                  label="Add"
                  [disabled]="accessBusy() || !accessReady()"
                  severity="success"
                  styleClass="additional-add-btn"
                  (click)="addAdditionalUser()" />
              </div>
              <small
                *ngIf="additionalEmailError"
                class="text-danger d-block mt-1"
                role="alert">
                {{ additionalEmailError }}
              </small>
            </div>
          } @else {
            <div
              class="flex-grow-1 min-vh-0 d-flex flex-column align-items-center justify-content-center text-center custom-padding">
              <span>
                Nadel Portal Access for this client is restricted. Please enable
                the client access from
                <a [routerLink]="clientGroupLink">here</a>.
              </span>
            </div>
          }
        </div>
      </p-tabpanel>

      <!-- Client Document Tab -->
      <p-tabpanel
        value="1"
        class="p-0 pt-1 h-100 flex-grow-1"
        [class.pe-none]="!isClientPortalEnabled"
        [class.opacity-75]="!isClientPortalEnabled"
        [attr.inert]="!isClientPortalEnabled ? '' : null">
        <div class="client-portal-content h-100 pt-2">
          <div
            class="client-document-content d-flex flex-column gap-2 flex-grow-1 min-vh-0 h-100"
            jniGlobalFileDrop
            [acceptedTypes]="[
              'pdf',
              'doc',
              'docx',
              'jpg',
              'jpeg',
              'png',
              'txt',
              'xlsx',
              'xls',
            ]"
            [maxFileSize]="30"
            [maxFiles]="10"
            [disabled]="
              isDisableLink || (clientDocFiles && clientDocFiles.length >= 10)
            "
            (filesDropped)="onClientFilesDropped($event)"
            (filesRejected)="onClientFilesRejected($event)"
            title="Drag and drop files anywhere in this area to upload">
            <!-- Top Left Text -->
            <div class="custom-padding">
              <h3 class="mb-0 fw-normal" style="font-size: 14px">
                All Files Will Be Viewable to the Client
              </h3>
            </div>

            <!-- File List -->
            <div
              *ngIf="clientDocFiles && clientDocFiles.length > 0"
              class="mb-2 overflow-auto client-file-list d-flex flex-column flex-grow-1 min-vh-0 align-self-stretch">
              <div
                *ngFor="let item of clientDocFiles"
                class="d-flex align-items-center justify-content-between mb-0 px-2 py-1 clientDocFiles custom-padding">
                <div
                  class="d-flex align-items-center gap-2 min-w-0 flex-grow-1 overflow-hidden">
                  <div>
                    <img
                      *ngIf="!item.isLink"
                      class="file-icon"
                      [src]="getFileIconClass(item.fileName)"
                      alt="icon" />
                    <i
                      *ngIf="item.isLink"
                      class="pi pi-link project-access-user-row-role fs-5"></i>
                  </div>
                  <div class="min-w-0 overflow-hidden">
                    <a
                      *ngIf="!item.isLink"
                      class="d-block link text-truncate"
                      [pTooltip]="item.fileName"
                      tooltipPosition="top"
                      (click)="
                        downloadClientDocFile(item.fileUrl, item.fileName)
                      ">
                      {{ item.fileName }}
                    </a>
                    <a
                      *ngIf="item.isLink"
                      class="d-block link text-truncate"
                      [href]="item.fileUrl"
                      rel="noopener noreferrer"
                      target="_blank"
                      [pTooltip]="item.fileName"
                      tooltipPosition="top">
                      {{ item.fileName }}
                    </a>
                  </div>
                </div>
                <div class="d-flex align-items-center gap-2">
                  <i
                    class="pi pi-pencil pointer project-access-user-row-role"
                    *ngIf="!isDisableLink && item.isLink"
                    (click)="openEditLinkDailog(item)"></i>
                  <i
                    class="pi pi-pencil pointer project-access-user-row-role"
                    *ngIf="!isDisableLink && !item.isLink"
                    (click)="
                      openRenameFileDailog(item.fileId, item.fileName)
                    "></i>
                  <i
                    class="pi pi-times pointer text-danger"
                    *ngIf="!isDisableLink && !item.isLink"
                    (click)="
                      deleteClientDocFileFromBlob(item.fileId, item.fileUrl)
                    "></i>
                  <i
                    class="pi pi-times pointer text-danger"
                    *ngIf="!isDisableLink && item.isLink"
                    (click)="deleteClientDocFile(item.fileId)"></i>
                </div>
              </div>
            </div>

            <!-- Hidden file input -->
            <input
              #clientFileInput
              type="file"
              style="display: none"
              (change)="onClientFileSelected($event)"
              [disabled]="isDisableLink" />

            <!-- Bottom Right Buttons -->
            <div class="d-flex gap-2 justify-content-end mt-auto px-2 pb-2">
              <p-button
                icon="pi pi-cloud-upload"
                label="Upload File"
                severity="success"
                [disabled]="
                  isDisableLink ||
                  (clientDocFiles && clientDocFiles.length >= 10)
                "
                (click)="uploadClientDocument()">
              </p-button>

              <p-button
                icon="pi pi-link"
                label="Add Link"
                severity="success"
                [disabled]="
                  isDisableLink ||
                  (clientDocFiles && clientDocFiles.length >= 10)
                "
                (click)="addClientDocumentLink()">
              </p-button>
            </div>
          </div>
        </div>
      </p-tabpanel>

      <!-- Project Link Tab -->
      <p-tabpanel
        value="2"
        [class.pe-none]="!isClientPortalEnabled"
        [class.opacity-75]="!isClientPortalEnabled"
        [attr.inert]="!isClientPortalEnabled ? '' : null">
        <div class="client-portal-content h-100">
          <div
            class="project-link-content d-flex justify-content-center flex-column align-items-center h-100 custom-padding">
            <div class="link-input-container d-flex mb-3 w-100">
              <h3 class="link-text mb-0">{{ clientPortalLink }}</h3>

              <i
                class="pi pi-copy copy-btn"
                (click)="copyClientPortalLink()"
                title="Copy link">
              </i>
            </div>

            <div class="project-link-buttons d-flex gap-2 w-100">
              <p-button
                icon="pi pi-sync"
                label="Email Proof & OC PDF"
                [disabled]="accessBusy() || !accessReady()"
                severity="success"
                (click)="openEmailTemplateModal()">
              </p-button>

              <p-button
                icon="pi pi-download"
                label="Download"
                severity="success"
                (click)="downloadClientPortalPdf()">
              </p-button>
            </div>
          </div>
        </div>
      </p-tabpanel>
    </p-tabpanels>
  </p-tabs>
</div>

<!-- Add Group Modal -->
<jni-add-group-modal
  [visible]="showAddGroupModal"
  [loading]="loadingGroups"
  [projectId]="workflowId ? workflowId.toString() : undefined"
  [customerAccount]="customerAccount"
  [availableGroups]="availableGroups"
  (visibleChange)="showAddGroupModal = $event"
  (createNewGroup)="openCreateNewGroupModal()"
  (groupsAdded)="onGroupsAdded($event)"
  (approvalsSubmitted)="onApprovalsSubmitted($event)">
</jni-add-group-modal>

<!-- Create New Group Modal -->
<jni-create-group-modal
  [visible]="showCreateNewGroupModal"
  [projectId]="workflowId ? workflowId.toString() : undefined"
  [customerAccount]="customerAccount"
  (visibleChange)="closeCreateNewGroupModal()"
  (groupCreated)="onGroupCreated()">
</jni-create-group-modal>

<!-- Nadel Portal Email Modal -->
<jni-client-portal-email-modal
  [visible]="showClientPortalEmailModal"
  [workflowId]="workflowId"
  [projectName]="projectName"
  [clientName]="clientName"
  [orderNumber]="salesOrderIdD365"
  [clientPortalLink]="clientPortalLink"
  [orderLines]="orderLines"
  [initialRecipients]="emailRecipients"
  [defaultAttachment]="emailDefaultAttachment"
  (visibleChange)="showClientPortalEmailModal = $event"
  (emailSent)="onEmailSent()">
</jni-client-portal-email-modal>

<!-- Rename File Dialog -->
<p-dialog
  header="Rename File"
  [position]="'center'"
  [modal]="true"
  appendTo="body"
  [resizable]="false"
  [draggable]="false"
  [(visible)]="showRenameFileDailog"
  [style]="{
    width: '300px',
    height: '250px',
    'border-radius': '10px',
    overflow: 'visible',
  }">
  <div class="p-fluid p-dir-col p-p-3">
    <div class="form-group has-float-label mt-2 mb-2">
      <label class="form-label" for="renameFileName">File Name</label>
      <input
        pInputText
        type="text"
        class="form-control"
        id="renameFileName"
        name="renameFileName"
        maxlength="450"
        [(ngModel)]="renameFileName" />
    </div>
    <div
      class="d-flex py-3 has-sticky justify-content-end p-0 align-items-center gap-3">
      <p-button
        label="Cancel"
        (click)="closeRenameFileDailog()"
        variant="outlined"
        severity="secondary" />
      <p-button label="Save" (click)="saveRenameFile()" />
    </div>
  </div>
</p-dialog>

<!-- Add/Edit File Link Dialog -->
<p-dialog
  header="{{ fileLinkModalHeader }}"
  [position]="'center'"
  [modal]="true"
  appendTo="body"
  [resizable]="false"
  [draggable]="false"
  [(visible)]="showFileLinkModal"
  [style]="{
    width: '300px',
    height: '320px',
    'border-radius': '10px',
    overflow: 'visible',
  }">
  <div class="p-fluid p-dir-col p-p-3">
    <div class="form-group has-float-label mt-2 mb-2">
      <label class="form-label" for="fileLink">File Link</label>
      <input
        pInputText
        type="text"
        class="form-control"
        id="fileLink"
        name="fileLink"
        [(ngModel)]="fileLink" />
    </div>
    <div class="form-group has-float-label mt-2 mb-2">
      <label class="form-label" for="fileLinkName">Link Name</label>
      <input
        pInputText
        type="text"
        class="form-control"
        id="fileLinkName"
        name="fileLinkName"
        [(ngModel)]="fileLinkName" />
    </div>
    <div
      class="d-flex py-3 has-sticky justify-content-end p-0 align-items-center gap-3">
      <p-button
        label="Cancel"
        (click)="closeFileLinkDailog()"
        variant="outlined"
        severity="secondary" />
      <p-button
        label="Update"
        (click)="editFileLink()"
        *ngIf="fileLinkMode === 'Edit'" />
      <p-button
        label="Save"
        (click)="addFileLink()"
        *ngIf="fileLinkMode === 'Add'" />
    </div>
  </div>
</p-dialog>
